export default __webpack_public_path__ + "static/Hexagons-Grid-background-Mobile-dba1ed6871115352ca0c856ae7eb2abf.svg";